module.exports = __webpack_public_path__ + "static/img/b2.89363b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b2.png
// module id = lxTt
// module chunks = 1